import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { CloseIcon, SparkIcon } from '@/components/icons';

export function QuickNavigation({ items }: { items: { label: string; to: string; icon: ReactNode }[] }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const open = () => { setQuery(''); if (!dialog.current?.open) dialog.current?.showModal(); };

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setQuery('');
        if (!dialog.current?.open) dialog.current?.showModal();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const results = items.filter(item => item.label.toLowerCase().includes(query.trim().toLowerCase()));
  return <>
    <button className="quick-jump" onClick={open} aria-label="Search navigation"><SparkIcon /><span>Quick navigation</span><kbd>Ctrl K</kbd></button>
    <dialog ref={dialog} className="command-dialog" aria-label="Quick navigation" onClick={event => { if (event.target === event.currentTarget) dialog.current?.close(); }}>
      <div className="command-search"><SparkIcon /><label htmlFor="navigation-search" className="sr-only">Find a page</label><input id="navigation-search" autoFocus placeholder="Where would you like to go?" value={query} onChange={event => setQuery(event.target.value)} /><button className="icon-button" aria-label="Close quick navigation" onClick={() => dialog.current?.close()}><CloseIcon /></button></div>
      <p className="command-caption">YOUR WORKSPACE, ONE SHORTCUT AWAY</p>
      <div className="command-results">{results.length ? results.map((item, index) => <button key={`${item.to}-${index}`} onClick={() => { dialog.current?.close(); navigate(item.to); }}><span className="command-icon">{item.icon}</span><span>{item.label}</span><span className="command-arrow" aria-hidden="true">↗</span></button>) : <p className="p-6 text-sm text-ink-muted">No pages found. Try “websites”, “reports”, or “settings”.</p>}</div>
      <div className="command-footer">Tab to browse <span>Esc to close</span></div>
    </dialog>
  </>;
}
